import { render } from "./renderFields.vue?vue&type=template&id=1988a0fd&scoped=true"
import script from "./renderFields.vue?vue&type=script&lang=js"
export * from "./renderFields.vue?vue&type=script&lang=js"

import "./renderFields.vue?vue&type=style&index=0&id=1988a0fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1988a0fd"]])

export default __exports__